import React from 'react'
import ToxicologyMain from '../components/toxicology-testing/ToxicologyMain'
import ToxicologyDrugTesting from '../components/toxicology-testing/ToxicologyDrugTesting'
import ToxicologyTestingPanel from '../components/toxicology-testing/ToxicologyTestingPanel'
import ToxicologyScreening from '../components/toxicology-testing/ToxicologyScreening'
import ToxicologyTestingTypes from '../components/toxicology-testing/ToxicologyTestingTypes'
import ToxicologyReliableDrugTesting from '../components/toxicology-testing/ToxicologyReliableDrugTesting'
import ToxicologyAccurateScreening from '../components/toxicology-testing/ToxicologyAccurateScreening'
import ToxicologyTestResults from '../components/toxicology-testing/ToxicologyTestResults'
import ToxicologyTestingProcess from '../components/toxicology-testing/ToxicologyTestingProcess'
import ToxicologySeamlessDrugTesting from '../components/toxicology-testing/ToxicologySeamlessDrugTesting'
import ToxicologyPanelConducting from '../components/toxicology-testing/ToxicologyPanelConducting'
import MainHeader from '../layout/MainHeader'
import TopHeader from '../layout/TopHeader'
import Footer from '../layout/Footer'
import CopyRight from '../layout/CopyRight'
import MainResHeader from '../layout/MainResHeader'
import ToxicologyTests from '../components/toxicology-testing/ToxicologyTests'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { useEffect } from 'react'

const ToxicologyTestingPage = () => {

  useEffect(()=>{
    window.scrollTo(0,0)
  },[])


  return (
    <div style={{ overflow:'hidden'}}>

    <HelmetProvider>
        <Helmet prioritizeSeoTags>
<title>Toxicology and Drug Testing In Chicago IL - United Lab Care</title>
<meta name="description" content="United Lab Care provides fast and confidential pre-work drug testing services in Chicago. Receive accurate toxicology test results with quick turnaround time." />
	<link rel="canonical" href="https://unitedlabcare.com/toxicology-and-drug-testing-chicago/" />
	<meta property="og:locale" content="en_US" />
	<meta property="og:type" content="article" />
	<meta property="og:title" content="Toxicology and Drug Testing In Chicago IL - United Lab Care" />
	<meta property="og:description" content="United Lab Care provides fast and confidential pre-work drug testing services in Chicago. Receive accurate toxicology test results with quick turnaround time." />
	<meta property="og:url" content="https://unitedlabcare.com/toxicology-and-drug-testing-chicago/" />
	<meta property="og:site_name" content="United Lab Care" />
	<meta property="article:modified_time" content="2023-06-23T05:51:03+00:00" />
	<meta property="og:image" content="https://unitedlabcare.com/wp-content/uploads/2023/05/Confusion-icon-ULC-Toxicology-Screening.png" />
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:label1" content="Est. reading time" />
	<meta name="twitter:data1" content="10 minutes" />
  </Helmet>
    </HelmetProvider>

        <TopHeader/>
        {/* <MainHeader/> */}
        <MainResHeader/>
        
        <ToxicologyMain/>
        <ToxicologyTests/>
        <ToxicologyDrugTesting/>
        <ToxicologyTestingPanel/>
        <ToxicologyScreening/>
        <ToxicologyTestingTypes/>
        <ToxicologyReliableDrugTesting/>
        <ToxicologyAccurateScreening/>
        <ToxicologyTestResults/>
        <ToxicologyTestingProcess/>
        <ToxicologySeamlessDrugTesting/>
        <ToxicologyPanelConducting/>

        <Footer/>
        <CopyRight/>
    </div>
  )
}

export default ToxicologyTestingPage